import React, { useEffect, useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { AnswerItem, QuestionValidationTypes, ReduxState } from 'interface';
import { QuestionSLPRef, SLPQuestionType } from '../../questions.index';
import { post } from 'scripts/api';
import { createQuestionTitle } from '../questionsTypes.script';
import SLPEmoji, { SLPEmojiRef } from 'utilities/slp/emoji/emoji.index';
import { extractTitle } from 'scripts/string';
import { API } from 'data';
import { __DropDownOption } from 'utilities/slp/dropdown/dropdown.interface';

const SLPEmojiQuestion: React.ForwardRefRenderFunction<
    QuestionSLPRef,
    ConnectedProps<typeof connector> & SLPQuestionType
> = (props: ConnectedProps<typeof connector> & SLPQuestionType, ref) => {
    React.useImperativeHandle(ref, () => ({
        validate: (e?: boolean) => validate(e),
        submit: (e?: boolean) => onSubmit(e),
    }));
    const lang = props.lang.SLP.questionsTypes;
    const question = props.question;
    const inputRef = useRef<SLPEmojiRef>(null);
    const emojis = question.items
        ?.sort((a, b) => (a.order ? a.order : a.id) - (b.order ? b.order : b.id))
        ?.map((item) => ({
            title: item.title,
            payload: item.id ? item.id : 0,
            value: item.value?.toString(),
            order: item.order,
            archive: item.archive,
        }));
    const [title, setTitle] = useState(question.title);
    const index = props.answerList?.findIndex((i) => i.question.id === question.id);

    function getValue(a: any) {
        if (question.validations) {
            return Number(question.validations.find((i) => i.title === a)?.value) === 1;
        }
    }

    const [hint, setHint] = useState(question.description);

    useEffect(() => {
        if (question.description)
            setHint(
                createQuestionTitle(
                    question.description,
                    props.answerList,
                    props.answer?.answerer_info,
                    props.form.indicators,
                ),
            );
        setTitle(
            createQuestionTitle(question.title, props.answerList, props.answer?.answerer_info, props.form.indicators),
        );
    }, [props.answerList]);

    function validate(e?: boolean) {
        if (question.is_required && !inputRef.current?.getValue()) {
            if (e) inputRef.current?.setError(lang.emojiEmp);
            return false;
        }
        return true;
    }

    function setAnswer() {
        const value = inputRef.current?.getValue();
        const data = [...props.answerList];
        if (value && validate()) {
            const response: AnswerItem = {
                question_items: [
                    {
                        title: value.title,
                        id: Number(value.payload),
                        payload: Number(value.payload),
                        value: value.value,
                        order: value.order,
                    },
                ],
                question: props.question,
                id: question.id,
                answer: props.answer?.id,
            };
            index !== undefined && index > -1 ? (data[index] = response) : data?.push(response);
        } else if (index !== undefined && index > -1) data.splice(index, 1);
        props.setAnswerList(data);
        // props.next();
    }

    function onSubmit(e?: boolean) {
        const value = inputRef.current?.getValue();
        if (value && validate(e) && props.answer) {
            props.submit({
                question_items: [
                    {
                        title: value.title,
                        payload: Number(value.payload),
                        id: Number(value.payload),
                        value: value.value,
                    },
                ],
                question: question,
                id: new Date().getTime(),
                created_at: new Date().toISOString(),
            });
        }
    }
    let defaultValue: __DropDownOption | undefined = undefined;
    if (index !== undefined && index > -1) {
        const value = props.answerList[index].question_items;
        if (value !== undefined)
            defaultValue = value.map((i) => ({
                title: i.title,
                payload: i.payload,
                value: i.value?.toString(),
            }))[0];
    }

    return (
        <SLPEmoji
            hint={extractTitle(hint, false, false)}
            ref={inputRef}
            counter={props.counter}
            label={extractTitle(title, false, false)}
            image={question.image_file}
            onChange={setAnswer}
            color={props.form?.answer_color}
            labelColor={props.form?.question_color}
            required={question.is_required}
            emojis={emojis ? emojis : []}
            showTitles={getValue(QuestionValidationTypes.emojiTitleShow)}
            dir={props.form.direction}
            defaultValue={
                index !== undefined && index > -1 && props.answerList[index].value
                    ? props.answerList[index].question_items?.map((i) => ({
                          title: i.title,
                          payload: i.payload,
                          value: i.value?.toString(),
                      }))[0]
                    : undefined
            }
        />
    );
};
const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPEmojiQuestion));
